import http from '@/utils/http';
const base_path = '/v2/tool/deepConvertGoal';

/**
 * 获取深度优化目标列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getDeepConvertGoalApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
